var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSaveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.731,
    height: 24,
    viewBox: "0 0 21.731 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8.5 -4.167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.088,8.853,25.822,4.331a.524.524,0,0,0-.381-.164h-13.8A3.145,3.145,0,0,0,8.5,7.309V25.025a3.145,3.145,0,0,0,3.142,3.142H27.089a3.145,3.145,0,0,0,3.142-3.142V9.212A.524.524,0,0,0,30.088,8.853ZM13.954,5.214h9.076v6.851H13.954ZM29.184,25.025a2.1,2.1,0,0,1-2.095,2.095H11.642a2.1,2.1,0,0,1-2.095-2.095V7.309a2.1,2.1,0,0,1,2.095-2.095h1.265v7.375a.524.524,0,0,0,.524.524H23.554a.524.524,0,0,0,.524-.524V5.214h1.137l3.968,4.206Zm-7.9-18.938a.524.524,0,0,0-.524.524v4.058a.524.524,0,1,0,1.047,0V6.611A.524.524,0,0,0,21.285,6.087Zm2.269,12.393H13.431a.524.524,0,0,0,0,1.047H23.554a.524.524,0,0,0,0-1.047Zm0,2.618H13.431a.524.524,0,0,0,0,1.047H23.554a.524.524,0,0,0,0-1.047Zm0,2.618H13.431a.524.524,0,0,0,0,1.047H23.554a.524.524,0,0,0,0-1.047Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon);
export default __webpack_public_path__ + "static/media/saveIcon.2f3c0606.svg";
export { ForwardRef as ReactComponent };